<ng-container *ngIf="data && data.inputs">
  <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: cardTitle | translate }"></ng-container>
</ng-container>

<ng-template #headerTemplate let-cardTitle>
  <bw-card-legacy cardType="active-product" [title]="cardTitle | translate" (cardAction)="cardTitleActionHandler.emit()">
    <bw-card-body-legacy>
      <hr class="separator" />
      <div class="flex-row space-between mt-sm pt-xs">
        <div class="pt-sm">
          <typography-legacy title-medium>{{ title | translate }}</typography-legacy>
          <p text-large-regular class="mb-smd" color="var(--secondary-text)">{{ subTitle | translate }}</p>
          <typography-legacy headline-semibold>{{ promoTitle | translate }}</typography-legacy>

          <a bw-anchor-legacy [anchorUnderline]="true" class="mt-sm" (click)="handleMoreInfoAction($event)"><typography-legacy text-small-regular>{{ promoMoreInfoTitle | translate }}</typography-legacy></a>
        </div>
        <div>
          <ui-media [data]="[promoMedia]"></ui-media>
        </div>
      </div>
    </bw-card-body-legacy>
  </bw-card-legacy>
</ng-template>
